'use client';

import { cn } from '@/lib/utils';
import Image from 'next/image';
import React, { useEffect } from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  className?: string;
  darkness?: number;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  className,
  darkness = 90,
}) => {
  useEffect(() => {
    if (isOpen && document !== undefined) {
      document.body.classList.add('overflow-hidden');
    }

    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, [isOpen]);

  if (isOpen) {
    return (
      <div
        className="fixed w-screen h-[150vh] overflow-hidden top-0 bottom-0 z-50"
        style={{ zIndex: 999 }}
      >
        <div
          style={{ opacity: darkness + '%' }}
          onClick={onClose}
          className="fixed z-50 inset-0 bg-black "
        ></div>
        <div
          className={cn(
            'max-w-xl w-[90%] max-h-[100dvh] fixed bg-white rounded-xl p-5 lg:p-10 z-50 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 overflow-auto',
            className
          )}
        >
          <div className="flex flex-col relative h-full">
            <Image
              onClick={onClose}
              src={'/icons/closecircle.svg'}
              alt=""
              width={30}
              height={30}
              className="cursor-pointer hover:invert absolute right-0 top-0 w-6 lg:w-7"
            />
            {title && (
              <h3 className="text-center font-bold text-2xl lg:text-3xl mb-5">
                {title}
              </h3>
            )}
            {children}
          </div>
        </div>
      </div>
    );
  }
};

export default Modal;
